<template>
  <span class="spectra-wordmark" translate="no">
    SPECTRA<span class="pay">PAY</span>
  </span>
</template>
